import { gql } from '@apollo/client';

import PAYMENT_PENDING_PAYMENT from './PAYMENT_PENDING_PAYMENT';

export default gql`
  query booking($reference: String!, $currency: Currency) {
    booking(reference: $reference) {
      reference
      status
      totalPriceToBePaid: totalPriceToBePaidWithCurrency(currency: $currency)
      customer {
        email
      }
      payments {
        ...PaymentPendingPayment
      }
      amountDue: amountDueWithCurrency(currency: $currency) {
        amount
        currency
      }
      onHold: onHoldWithCurrency(currency: $currency) {
        depositAmount
      }
      isPackage
      hotels {
        itemRef
      }
    }
  }

  ${PAYMENT_PENDING_PAYMENT}
`;
